import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import React, { useState } from 'react';
import {
  FDPrimaryActionButton,
  FDStack,
  FDTitleText,
} from '@facet-wealth/design';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import PropTypes from 'prop-types';
import metaOverrideSet from '../../metaOverrideSet';

const FacetPlanCustomStrategySetupAddableForm = ({ label, attrName, resourceLayout }) => {
  const { resource, handleChange } = useMetaLayoutContext();

  const [, setFormResource] = useState();

  const handleAdd = () => {
    // create new empty resource
    resource.attr(attrName).resources().pushItem(null, resource.attr(attrName).create());

    setFormResource(resource.attr(attrName).create());
  };

  const handleDelete = (index) => {
    resource.attr(attrName).resources().removeItemByIndex(index);
    handleChange(attrName, resource.attr(attrName)); // this sets the value and triggers a re-render so the deleted items disappear
  };

  return (
    <FDStack direction={'column'} spacing={2}>
      <FDTitleText value={label} />
      {resource.attr(attrName).resources().list().map((entry, i) => {
        return (
          <MetaResourceRenderer
            resource={entry}
            layout={resourceLayout}
            metaOverrideSet={metaOverrideSet}
            LayoutProps={{ onDelete: () => handleDelete(i) }}
          />
        );
      })}
      <FDStack>
        <FDPrimaryActionButton
          icon="add"
          iconPosition="start"
          label="Add"
          onClick={() => handleAdd(resource)}
          size="sm"
        />
      </FDStack>
    </FDStack>
  );
};

FacetPlanCustomStrategySetupAddableForm.propTypes = {
  label: PropTypes.string.isRequired,
  attrName: PropTypes.string.isRequired,
  resourceLayout: PropTypes.object.isRequired,
};

export default FacetPlanCustomStrategySetupAddableForm;
